import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import { formatInZone } from '../../common/clock';

/**
 * /yarismalar — upcoming contests and past results.
 */
export default class ContestIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = true;
    this.upcoming = [];
    this.past = [];

    app
      .request({
        method: 'GET',
        url: `${app.forum.attribute('apiUrl')}/happy-quiz/contests`,
      })
      .then((response) => {
        this.upcoming = response.data.upcoming || [];
        this.past = response.data.past || [];
        this.loading = false;
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }

  view() {
    return (
      <div className="HappyQuiz HappyQuizIndex">
        <header className="HappyQuizIndex-header">
          <div className="HappyQuizIndex-heading">
            <span className="HappyQuiz-badge">{app.translator.trans('happydigital-quiz.forum.card.eyebrow')}</span>
            <h1>{app.translator.trans('happydigital-quiz.forum.index.title')}</h1>
            <p>{app.translator.trans('happydigital-quiz.forum.index.description')}</p>
          </div>

          {/* Only managers see this; the endpoints authorise independently. */}
          {app.forum.attribute('happyQuizCanManage') ? (
            <Link className="Button Button--primary HappyQuiz-newButton" href={app.route('happyQuiz.create')}>
              {app.translator.trans('happydigital-quiz.forum.wizard.new_contest')}
            </Link>
          ) : null}
        </header>

        {this.loading ? <LoadingIndicator /> : this.content()}
      </div>
    );
  }

  content() {
    return (
      <div className="HappyQuizIndex-sections">
        {this.section('upcoming', this.upcoming)}
        {this.section('past', this.past)}
      </div>
    );
  }

  section(kind, contests) {
    const past = kind === 'past';
    return (
      <section className="HappyQuizIndex-section" aria-labelledby={`HappyQuizIndex-${kind}`}>
        <div className="HappyQuizIndex-sectionHeading">
          <h2 id={`HappyQuizIndex-${kind}`}>
            {app.translator.trans(`happydigital-quiz.forum.index.${kind}_heading`)}
          </h2>
          <span className="HappyQuizIndex-count">{contests.length}</span>
        </div>
        {contests.length ? (
          <div className="HappyQuizIndex-list">{contests.map((contest) => (
            <div key={contest.id}>
              {this.item(contest, past)}
              {!past && app.forum.attribute('happyQuizCanManage') ? (
                <div className="HappyQuizIndex-management">
                  <Link className="Button Button--text" href={app.route('happyQuiz.edit', { id: contest.id })}>
                    {app.translator.trans('happydigital-quiz.forum.wizard.edit_heading')}
                  </Link>
                  {contest.cardVisibleAt ? <small>{app.translator.trans('happydigital-quiz.forum.wizard.card_schedule', {
                    time: formatInZone(contest.cardVisibleAt, contest.timezone), timezone: contest.timezone,
                  })}</small> : null}
                </div>
              ) : null}
            </div>
          ))}</div>
        ) : (
          <div className="HappyQuizIndex-empty">
            <i className={`fas ${past ? 'fa-trophy' : 'fa-calendar-alt'}`} aria-hidden="true" />
            <p>{app.translator.trans(`happydigital-quiz.forum.index.empty_${kind}`)}</p>
          </div>
        )}
      </section>
    );
  }

  item(contest, past) {
    return (
      <Link className={'HappyQuizIndex-item' + (past ? ' is-past' : '')} href={app.route('happyQuiz.show', { slug: contest.slug })}>
        <span className="HappyQuizIndex-icon" aria-hidden="true">
          <i className={`fas ${past ? 'fa-trophy' : 'fa-calendar-alt'}`} />
        </span>
        <span className="HappyQuizIndex-body">
          <span className="HappyQuizIndex-title">{contest.title}</span>
          <time className="HappyQuizIndex-date" dateTime={contest.state.startsAt}>
            {formatInZone(contest.state.startsAt, contest.timezone)}
          </time>
          <span className="HappyQuizIndex-meta">
            <span>{app.translator.trans('happydigital-quiz.forum.index.question_count', { count: contest.questionCount })}</span>
            <span>{app.translator.trans('happydigital-quiz.forum.results.participants', { count: contest.participantCount || 0 })}</span>
          </span>
          <span className="HappyQuizIndex-action">
            {app.translator.trans(`happydigital-quiz.forum.card.${past ? 'see_results' : 'review'}`)}
            <i className="fas fa-arrow-right" aria-hidden="true" />
          </span>
        </span>
      </Link>
    );
  }
}
